import axios from "@/utils/request.js";
import qs from "qs"
//  账号密码登录
const userLogin = (params) => axios({
  url: '/api/web-basic/login/back/remix',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})

//  token登录
const userLoginByToken = (params) => axios({
  url: '/api/web-basic/login/back/user',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    "token":params.token
  },
  data: qs.stringify(params)
})


//  用户退出登录
const userLogOut = (params) => axios({
  url: '/api/web-basic/login/back/out',
  method: 'post',

  data: qs.stringify(params)
})
// 通过手机号登录
const userLoginByMobile = (params) => axios({
  url: '/api/web-basic/login/back/mobile',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 获取用户权限
const getRouter = () => axios.get('/api/web-conf/role/perms/user')

const smsManager = (params) => axios({
  url: '/api/web-basic/sms/manager/login',
  method: 'post',
  data: qs.stringify(params)
})

// 修改路由名称和图标
const configurationRouterEdit = (params) => axios({
  url: '/api/web-conf/configuration/router/edit',
  method: 'post',
  data: params
})
//获取用户快捷路由配置
const getUserQuick = (params) => axios({
  url: '/api/web-conf/role/perms/used/list',
  method: 'get',
  params
})
// 获取二维码code
const getLoginQrcode = (params) => axios({
  url: '/api/web-basic/login/back/qrcode',
  method: 'get',
  params
})
const timeOutGetCode = (params) => axios({
  url: '/api/web-basic/login/back/qrcode',
  method: 'post',
  data: qs.stringify(params)
})


// 
// 用过户修改密码
const userUpdatePassword = (params) => axios({
  url: '/api/web-conf/user/manager/password/editOrSet',
  method: 'post',
  data: qs.stringify(params)
})
//修改账号
const userUpdateAccount = (params) => axios({
  url: '/api/web-conf/user/manager/account/set',
  method: 'post',
  data: qs.stringify(params)
})
// 获取用户详情
const getUserDetail = (data) =>
  axios.get("/api/web-conf/user/manager/detail", {
    params: data
  });
// 获取我的用户信息详情
const userManagerDetailInfo = (params) => axios.get('/api/web-conf/user/manager/my/detail', {
  params
})

// 修改|设置用户手机号
const userManagerMobileSet = (data) => axios({
  url: '/api/web-conf/user/manager/mobile/editOrSet',
  method: 'post',
  data: qs.stringify(data)
})

// 修改我的用户信息
const userManagerDetailInfoEdit = (data) => axios({
  url: '/api/web-conf/user/manager/mydata/edit',
  method: 'post',
  data: qs.stringify(data)
})


// 修改|设置密码
const userManagerPasswordEdit = (data) => axios({
  url: '/api/web-conf/user/manager/password/editOrSet',
  method: 'post',
  data: qs.stringify(data)
})
// 通过验证码修改密码
const userManagerPassword = (data) => axios({
  url: '/api/web-conf/user/manager/password',
  method: 'post',
  data: qs.stringify(data)
})


// 网站前端用户手机号登录

const userManagerWebLogin = (data) => axios({
  url: '/api/web-basic/login/web/mobile',
  method: 'post',
  data: qs.stringify(data)
})

// 判断是否在白名单中
const whiteuserCheck = (params) => axios({
  url: '/api/web-manager/live/whiteuser/check',
  method: 'get',
  params
})


// 网站前端用户 账号密码登录

const userManagerWebLoginByAccount = (data) => axios({
  url: '/api/web-basic/login/web/account',
  method: 'post',
  data: qs.stringify(data)
})
//获取用户创作中心域名

const getuccPath = (params) => axios({
  url: '/api/web-basic/tenant/manager/create/path',
  method: 'get',
  params
})
//   注销账户
const managerLogOut = (params) => axios({
  url: '/api/web-conf/user/manager/logout',
  method: 'post',
  data: qs.stringify(params)
})
export {
  userLogOut,
  userLogin,
  userLoginByToken,
  getRouter,
  userLoginByMobile,
  smsManager,
  configurationRouterEdit,
  getUserQuick,
  getLoginQrcode,
  timeOutGetCode,
  userUpdatePassword,
  getUserDetail,
  userManagerDetailInfo,
  userManagerMobileSet,
  userManagerDetailInfoEdit,
  userManagerPasswordEdit,
  userManagerPassword,
  userManagerWebLogin,
  userManagerWebLoginByAccount,
  userUpdateAccount,
  getuccPath,
  managerLogOut,
  whiteuserCheck
}